import fundaNowClient from '@/client/fundaNowClient'
import AuthService from '@/service/auth/AuthService'
import HttpUtil from '@/util/HttpUtil'

export default {
  getMe() {
    return fundaNowClient.call({
      url: '/users/me/',
      method: 'GET'
    })
  },
  patchMe(data) {
    if (!AuthService.getProfile()) { return }
    return fundaNowClient.call({
      url: `/users/${AuthService.getProfile().uuid}/`,
      method: 'PATCH',
      data: data
    })
  },
  patchStore(data) {
    if (!AuthService.getProfile()) { return }
    return fundaNowClient.call({
      url: `/stores/${AuthService.getProfile().uuid}/`,
      method: 'PATCH',
      data: data
    })
  },
  getStatus() {
    if (!AuthService.getProfile()) { return }
    return fundaNowClient.call({
      url: `/users/${AuthService.getProfile().uuid}/status/`,
      method: 'GET'
    })
  },
  postUtmParams(data) {
    return fundaNowClient.call({
      url: '/tracking/utm-parameters/',
      method: 'POST',
      data: data
    })
  },
  getPrefetchUser(params) {
    return fundaNowClient.call({
      url: '/prefetch/user/',
      method: 'GET',
      params: params
    })
  },
  getNickname(params) {
    return fundaNowClient.call({
      url: '/user/nickname/',
      method: 'GET',
      params: params
    })
  },
  getBanks() {
    return fundaNowClient.call({
      url: '/choices/banks/',
      method: 'GET'
    })
  },
  getCollectionAccount() {
    return fundaNowClient.call({
      url: `/collection-accounts/${AuthService.getProfile().uuid}/`,
      method: 'GET',
    })
  },
  putCollectionAccount(userUuid, account) {
    return fundaNowClient.call({
      url: `/collection-accounts/${userUuid}/`,
      method: 'PUT',
      data: account
    })
  },
  putWithdrawalAccount(userUuid, account) {
    return fundaNowClient.call({
      url: `/withdrawal-accounts/${userUuid}/`,
      method: 'PUT',
      data: account
    })
  },
  postVerifyWithdrawalAccount(userUuid, verifyWord) {
    return fundaNowClient.call({
      url: `/withdrawal-accounts/${userUuid}/verify/`,
      method: 'POST',
      data: {
        'verify_word': verifyWord
      }
    })
  },
  getAccountOwner(urlParams) {
    return fundaNowClient.call({
      url: '/funda-pay-gate/account-holder-name' + HttpUtil.jsonToQueryString(urlParams),
      method: 'GET'
    })
  },
  getWithdrawalAccounts() {
    return fundaNowClient.call({
      url: `/withdrawal-accounts/${AuthService.getProfile().uuid}/`,
      method: 'GET'
    })
  },
  arsAuth(data) {
    return fundaNowClient.call({
      url: '/bnk/ars-auth/',
      method: 'POST',
      data: data
    })
  },
}
